module.exports = __webpack_public_path__ + "img/plan-03.25d16b2a.png";